import { setCookie, clearCookie } from '../utils/cookies';
export default {
  // 存储token
  setToken (state, data) {
    state.token = data.token;
    if (data.token) {
      state.isLogin = true;
    } else {
      state.isLogin = false;
    }
    window.localStorage.setItem('ssToken', data.token);
    setCookie('sspai_jwt_token', data.token);
    setCookie('sspai_cross_token', data.token, 1, 'sspai.com');
  },
  // 存储用户信息
  setUserInfo (state, user) {
    state.userInfo = user;
    state.isPrime = !!(user && user.member && user.member.is_pay && !user.member.is_expire)
  },
  // 登出
  logout (state) {
    state.token = '';
    state.userInfo = null;
    state.isLogin = false;
    state.loginTime = null;
    window.localStorage.setItem('ssToken', '');
    clearCookie('sspai_jwt_token');
    clearCookie('sspai_cross_token', 'sspai.com');
  },
  // 存储设备类型
  setTerminalType (state, type) {
    state.terminalType = type;
  },
  // 设置全站配置
  setSetting (state, setting) {
    state.setting = setting;
  },
  setPageData (state, data) {
    state.pageData = data;
  },
  setAction (state, data) {
    state.action = data
  },
  setHistory (state, data) {
    state.history = data
  },
  setSeriesInfo (state, data) {
    state.series = data
  }
};
